// Redux
import { Dispatch } from "redux";

// Classes
import { AgeReducerState } from "../classes/age.classes";
import { Range } from "Containers/Filter/classes/filter.classes";

// Action Creators
import {
  setSelection,
  setValue,
  setAgeState
} from "../actionCreators/age.actionCreators";

export const setSelectionOrValue = (
  dispatch: Dispatch<any>,
  age: any,
  value: any,
  identifier: "selectionAge" | "value"
) => {
  if (identifier === "selectionAge") {
    dispatch(setSelection(value));
    if (age.selection !== value) {
      switch (value) {
        case "Specific Age Range":
          dispatch(setValue(new Range(13, 40)));
          break;
      }
    }
  } else {
    dispatch(setValue(new Range(value[0], value[1])));
  }
};

export const initializeAgeState = (
  dispatch: Dispatch<any>,
  state: AgeReducerState
) => {
  dispatch(setAgeState(state));
};
